/**
 * Helper functions for animation enter/leave state
 */

/**
 * Enter element in stages
 */
export function stageEntry (elementId: string): void {
	const element = document.querySelector(elementId);
	if (!element) { return; }

	const existingAttribute = element.getAttribute('data-state');
	if (!existingAttribute) {
		element.setAttribute('data-state', 'animation-initial-load');
	} else {
		element.setAttribute('data-state', 'animation-ready');
	}
}

/**
 * Enter element straight away
 */
export function immediateEntry (elementId: string): void {
	const element = document.querySelectorAll(elementId);
	if (!element) { return; }

	(element || []).forEach((_: Element) => {
		_.setAttribute('data-state', 'animation-ready');
	});
}

/**
 * Leave element in stages
 */
 export function stageLeave (elementId: string): void {
	const element = document.querySelectorAll(elementId);
	if (!element) { return; }

	(element || []).forEach((_: Element) => {
		_.setAttribute('data-state', 'animation-leave');
	});
}


/**
 * Leave element straight away
 */
export function immediateLeave (elementId: string): void {
	const element = document.querySelectorAll(elementId);
	if (!element) { return; }

	(element || []).forEach((_: Element) => {
		_.setAttribute('data-state', '');
	});
}

/**
 * Bespoke entry helper function 
 */
export function stageMultipleLayerEntry (elementId: string, stageId: string): void {
	const element = document.querySelectorAll(elementId);
	if (!element) { return; }

	(element || []).forEach((_: Element) => {
		_.setAttribute('data-state', 'animation-ready');
		_.setAttribute('data-stage', stageId);
	});
}

export function stageMultipleLayerLeave (elementId: string): void {
	const element = document.querySelectorAll(elementId);
	if (!element) { return; }

	(element || []).forEach((_: Element) => {
		_.setAttribute('data-state', 'animation-leave');
		_.setAttribute('data-stage', '');
	});
}